<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 14.4983C10.9344 14.4991 10.8694 14.4861 10.8091 14.4603C10.7489 14.4345 10.6946 14.3963 10.65 14.3483L6.15 9.84828C5.95 9.64828 5.95 9.33828 6.15 9.13828C6.35 8.93828 6.66 8.93828 6.86 9.13828L11.01 13.2883L15.15 9.14828C15.35 8.94828 15.66 8.94828 15.86 9.14828C16.06 9.34828 16.06 9.65828 15.86 9.85828L11.36 14.3583C11.26 14.4583 11.13 14.5083 11.01 14.5083L11 14.4983Z"
      fill="#213E7A"
    />
    <rect x="0.5" y="0.5" width="21" height="21" rx="4.5" stroke="#213E7A" />
  </svg>
</template>

<script>
export default {
  name: "DropdownNew",
};
</script>

<style></style>
